
export enum MessageType {
    SMS = "SMS",
    WhatsApp = "WhatsApp",
    Email = "Email"
}

export enum WhatsAppTemplates {
    VerifyPin = "HXa4b13c40be4df6dfffc8ff47f83b5a02",
    NotifyOrderStatusChange = "HX0c0afe08444858ee759f4aaf8ba50033",
    ConfirmNewOrder = "HXe3ac2d078629c1cf65301acc93ac9e74",
    WelcomeMessage = "HX7e2fd4f935ed7bada7fed10f84e3d3b7"
}

export interface SendMessageRequest {
    messageType: MessageType;
    toAddress: string | null;
    message: string;
    subject: string;
    whatsappTemplate?: WhatsAppTemplates;
    whatsappTemplateParams?: {[key: string]: string}
}

export const MessageGateway = {
    SendMessage: async (
        data: SendMessageRequest,
        idToken: string,
        clientKey: string
    ): Promise<Response> => {
        
        const response = await fetch(`${process.env.REACT_APP_MESSAGE_API_HOST}/send`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${idToken}`,
                "x-client-key": clientKey
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error(`Error sending the message. (Status code: ${response.status})`,errorData)
            throw new Error(errorData.message || "Failed to send message");
        }

        return response;
    }
}